module.exports = __webpack_public_path__ + "static/avatar-044f537af65fe3fe4a8a8a22fe72e67b.png";